export default __webpack_public_path__ + "static/media/calendar-svgrepo-com.51738457.svg";